<div>
    <bko-tilbake-link></bko-tilbake-link>
    <!--^fungerer ikke om jeg reloader siden-->
    <div class="share-section">

        <h1>Last ned ditt Boligkompass</h1>
        <p>
            Last ned en samlet PDF med resultatene fra kartleggingen. Rapporten gir deg oversikt over funn, utfordringer
            og aktuelle tiltak.
        </p>

        <button class="download-button" (click)="lastNedPdf()">
            <img src="assets/images/download.svg" alt=""/>
            <span>Last ned resultat som PDF</span>
        </button>
        <bko-last-ned-pdf-card></bko-last-ned-pdf-card>
    </div>


</div>
